import { Directive, HostListener, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[appNumberFormat]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberformatDirective),
      multi: true
    }
  ],
  standalone: true // Added if you are using Angular 14+
})
export class NumberformatDirective implements ControlValueAccessor {
  // Initialize as empty functions to avoid 'null' errors
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    // Ensure nativeElement exists and format the value
    if (this.el.nativeElement) {
      this.el.nativeElement.value = this.format(value);
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  // Change: Listen to the whole event to cast the target correctly
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    // Cast EventTarget to HTMLInputElement to access .value
    const input = event.target as HTMLInputElement;
    const value = input.value;
    
    const cleanValue = value.replace(/,/g, '');
    const numericValue = cleanValue ? parseFloat(cleanValue) : null;

    // Update the Form Control
    this.onChange(numericValue);
    
    // Update the UI with formatted commas
    input.value = this.format(cleanValue);
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  private format(value: any): string {
    if (value === null || value === undefined || value === '') return '';
    
    // Convert string to number if necessary for Intl.NumberFormat
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('en-IN').format(num);
  }
}